export default "__VITE_ASSET__f08b02c7__"